import { BRAND_COPY } from '@fyf/shared';

import { EmberReveal } from '../components/EmberReveal.js';
import { ScreenLayout } from '../components/ScreenLayout.js';
import { useCaptureDispatch, useCaptureState } from '../context/CaptureFlowContext.js';

const { reveal } = BRAND_COPY.screens;

export function RevealScreen() {
  const { flameImageUrl, error, displayName, firstName } = useCaptureState();
  const dispatch = useCaptureDispatch();
  const name = displayName || firstName || 'Firestarter';

  if (error) {
    return (
      <ScreenLayout>
        <h2 className="text-2xl font-serif text-center mb-4 text-red-400">Something went wrong.</h2>
        <p className="text-gray-300 text-center">{error}</p>
      </ScreenLayout>
    );
  }

  return (
    <ScreenLayout glowIntensity="high">
      <h1 className="text-[32px] font-['Lora',serif] text-center mb-2">
        This is <span className="text-brand-gradient italic">your</span> fire.
      </h1>

      {flameImageUrl && <EmberReveal imageUrl={flameImageUrl} displayName={name} />}

      <div className="flex flex-col gap-6 items-center mt-4">
        <div className="text-center">
          <h3 className="text-[24px] font-medium font-['Lora',serif] text-brand-gradient mb-3">
            {reveal.muralCallout}
          </h3>
          <p className="font-['DM_Sans',sans-serif] text-base text-[#F9F7F4] max-w-md mb-3">
            {reveal.muralText}
          </p>
          <p className="font-['DM_Sans',sans-serif] text-base text-[#F9F7F4] max-w-md">
            {reveal.notebookPrompt}
          </p>
        </div>

        <a
          href={reveal.ctaUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full max-w-md block text-center py-2 rounded-full border border-[#757575] font-['DM_Sans',sans-serif] text-base text-[#F9F7F4] hover:border-[#f97216] transition-colors"
          style={{ backgroundImage: 'var(--glass-gradient)' }}
        >
          {reveal.cta}
        </a>

        {flameImageUrl && (
          <button
            onClick={() => dispatch({ type: 'SET_SCREEN', payload: 'share' })}
            className="flex items-center gap-2 justify-center font-['DM_Sans',sans-serif] text-base text-[#F9F7F4] hover:text-[#f97216] transition-colors"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
            </svg>
            {reveal.shareLink}
          </button>
        )}
      </div>
    </ScreenLayout>
  );
}
